import React from "react";
import {
  Anchor,
  Type,
  CallToAction,
} from "discover.medical.react-component-library";
import { appendAmplitudeDeviceId, appendReturnToUrl } from "../../util/userActions";

export const SubscribeCard = () => {
  return (
    <CallToAction
      avatar={false}
      center={true}
      borderWidth="0"
      padding="lg"
      marginBottom="lg"
    >
      <Type element="p">
        <Anchor href={appendReturnToUrl("/store")}>Subscribe</Anchor> to
        personalize your alerts. Already subscribed?{" "}
        <Anchor href={appendAmplitudeDeviceId(appendReturnToUrl("/login"))}>Sign in.</Anchor>
      </Type>
    </CallToAction>
  );
};
